/**
 * PlotTrack is one outline door (#817 / #849). The book you open is
 * the grid you see. No second book↔series path.
 */
export function plottrackPath(storyId) {
  return storyId ? `/plottrack/${storyId}` : '/plottrack';
}

/**
 * The book you are in — the one the left map is for — not most-recent
 * and not last-in-series. Used by the book-map PlotTrack door so the
 * URL on first paint is that book.
 */
export function plottrackBookId({ pathname = '', currentStory, currentSession } = {}) {
  const notes = (pathname || '').match(/^\/projects\/[^/]+\/stories\/([^/]+)\/notes\/?$/);
  if (notes?.[1]) return notes[1];

  const onPlottrack = (pathname || '').match(/^\/plottrack\/([^/]+)/);
  if (onPlottrack?.[1]) return onPlottrack[1];

  if ((pathname || '').startsWith('/chat/') && currentSession?.story_id) {
    return currentSession.story_id;
  }

  return currentStory?.id || currentSession?.story_id || null;
}

export function plottrackPathForBook(ctx) {
  return plottrackPath(plottrackBookId(ctx));
}
